import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M 39.027 66 C 35.2124 66 31.7755 65.1392 28.7166 63.4176 C 25.6937 61.6593 23.3185 59.2601 21.5911 56.2198 C 19.8637 53.1429 19 49.7363 19 46 C 19 42.2637 19.8637 38.8755 21.5911 35.8352 C 23.3185 32.7582 25.6937 30.359 28.7166 28.6374 C 31.7755 26.8791 35.2124 26 39.027 26 C 42.8057 26 46.2065 26.8791 49.2294 28.6374 C 52.2883 30.359 54.6815 32.7582 56.4089 35.8352 C 58.1363 38.8755 59 42.2637 59 46 C 59 49.7363 58.1363 53.1429 56.4089 56.2198 C 54.6815 59.2601 52.2883 61.6593 49.2294 63.4176 C 46.2065 65.1392 42.8057 66 39.027 66 Z M 25.9096 46 C 25.9096 48.5275 26.4674 50.8168 27.583 52.8681 C 28.7346 54.9195 30.3001 56.5311 32.2794 57.7033 C 34.2947 58.8755 36.5439 59.4615 39.027 59.4615 C 41.4742 59.4615 43.6874 58.8755 45.6667 57.7033 C 47.6459 56.5311 49.1935 54.9195 50.309 52.8681 C 51.4607 50.8168 52.0364 48.5275 52.0364 46 C 52.0364 43.4725 51.4607 41.1832 50.309 39.1319 C 49.1935 37.0806 47.6459 35.4689 45.6667 34.2967 C 43.6874 33.1245 41.4742 32.5385 39.027 32.5385 C 36.5439 32.5385 34.2947 33.1245 32.2794 34.2967 C 30.3001 35.4689 28.7346 37.0806 27.583 39.1319 C 26.4674 41.1832 25.9096 43.4725 25.9096 46 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
